import React from 'react';
import { HammerIcon, HardHatIcon, XIcon } from 'lucide-react';
import { GUESSWORK } from '../../data/catio';
const PATHS = [{
  icon: HammerIcon,
  label: 'Build it yourself'
}, {
  icon: HardHatIcon,
  label: 'Give the plan to your builder'
}];

/** DIY reassurance + cost of guesswork, merged into one honest section. */
export function ObjectionSection() {
  return <section aria-labelledby="diy-title" className="bg-ivory py-12 sm:py-20" data-id="element-193" data-mp="2eiwf4znvb8zu">
      <div className="mx-auto grid w-full max-w-6xl gap-10 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-194" data-mp="32bmp53c7ni7h">
        <div data-id="element-195" data-mp="36bn913i2wllx">
          <h2 id="diy-title" className="font-display text-[1.85rem] leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-196" data-mp="36a3tjf48yel7">
            Designed to Remove the Planning — Not the Building
          </h2>
          <p className="mt-4 text-[1rem] leading-relaxed text-graphite sm:text-[1.05rem]" data-id="element-197" data-mp="1gwyzrb4sbjs4">
            You don’t need to design the structure yourself. CATIO READY™ gives you the plan. You
            should still be comfortable using basic DIY tools safely, measuring, cutting and
            assembling — or you can hand the plan to a handyman or carpenter.
          </p>

          <div className="mt-6 grid gap-2" data-id="element-198" data-mp="1iy0ea8jep2rb">
            {PATHS.map((path, index) => {
            const Icon = path.icon;
            return <React.Fragment key={path.label} data-id="element-199" data-mp="1rvarw0jp53ze" data-mpi={index}>
                  {index > 0 && <p className="label-tech text-center text-ember" data-id="element-200" data-mp="25vv9wuhsevru">or</p>}
                  <p className="flex items-center gap-4 rounded-[14px] border border-line bg-paper px-5 py-4" data-id="element-201" data-mp="25u0olf2lt1n8">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-wood-light text-wood" data-id="element-202" data-mp="2flwwfhuhs64n">
                      <Icon className="h-5 w-5" strokeWidth={1.8} aria-hidden data-id="element-203" data-mp="2anv220rm8kdv" />
                    </span>
                    <span className="font-display text-[1.3rem] leading-tight text-ink" data-id="element-204" data-mp="2pkvw4axa4rfi">
                      {path.label}
                    </span>
                  </p>
                </React.Fragment>;
          })}
          </div>
        </div>

        <div className="lg:pt-2" data-id="element-205" data-mp="2wn12arvosf4k">
          <h3 className="font-display text-[1.6rem] leading-[1.15] text-ink sm:text-[2rem]" data-id="element-206" data-mp="2woc3cjxqz8rz">
            Mistakes Cost More Than Plans
          </h3>
          <ul className="mt-5 grid grid-cols-2 gap-x-4 border-t border-line" data-id="element-207" data-mp="31kkivyfux3zo">
            {GUESSWORK.map(item => <li key={item} className="flex items-center gap-2.5 border-b border-line py-3.5 text-[0.95rem] leading-snug text-graphite" data-id="element-208" data-mp="3bcq6kvz2sz92">
                <XIcon className="h-4 w-4 shrink-0 text-ember" strokeWidth={2.25} aria-hidden data-id="element-209" data-mp="3kcvct2sj9rln" />
                {item}
              </li>)}
          </ul>
          <p className="mt-5 text-[1.05rem] font-semibold text-ink" data-id="element-210" data-mp="3pb6o7hyh8a5z">
            A clear plan removes unnecessary guesswork.
          </p>
        </div>
      </div>
    </section>;
}